
function LocalStorageClear() {
  // localStorage.clear();
  localStorage.removeItem('accessToken')
  localStorage.removeItem('userData')
  localStorage.removeItem('tempPDF')
  localStorage.removeItem('policy_detail')
}

export default LocalStorageClear